import { render, staticRenderFns } from "./PanelReservePolicy.vue?vue&type=template&id=679583c0&scoped=true"
import script from "./PanelReservePolicy.vue?vue&type=script&lang=js"
export * from "./PanelReservePolicy.vue?vue&type=script&lang=js"
import style0 from "./PanelReservePolicy.vue?vue&type=style&index=0&id=679583c0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679583c0",
  null
  
)

export default component.exports